interface GripVerticalIconProps {
    className?: string;
}

/** The centres of the six dots, in two columns of three, on a 24 × 24 grid. */
const DOTS = [
    [9, 12],
    [9, 5],
    [9, 19],
    [15, 12],
    [15, 5],
    [15, 19],
] as const;

/** The handle a row is dragged by: six dots in two columns, drawn in the current text colour. */
export const GripVerticalIcon = ({ className }: GripVerticalIconProps) => (
    <svg
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={2}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        className={className}
    >
        {DOTS.map(([cx, cy]) => (
            <circle
                key={`${cx}-${cy}`}
                cx={cx}
                cy={cy}
                r={1}
            />
        ))}
    </svg>
);
